<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_content" class="app-content flex-column-fluid">
    <!--begin::Content container-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
        <!--begin::Toolbar container-->
        <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
            <!--begin::Page title-->
            <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                <!--begin::Title-->
                <div class="d-flex align-items-center">
                    <h1 class="page-heading"><svg width="29" height="28" viewBox="0 0 29 28" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_339_1096)">
                                <path
                                    d="M23.7844 8.7727C23.7311 8.08605 23.1655 7.5484 22.4809 7.52574C21.5601 7.49553 20.6795 6.99702 20.1992 6.13527C19.7128 5.27147 19.7422 4.25522 20.1904 3.44635C20.5299 2.83317 20.3345 2.06618 19.7641 1.66037C19.318 1.34314 18.8432 1.06367 18.3445 0.826092C17.7105 0.523966 16.9468 0.729961 16.5813 1.33147C16.1017 2.12043 15.2382 2.64709 14.2483 2.64709C13.2585 2.64709 12.3956 2.12043 11.9154 1.33147C11.5492 0.729274 10.7861 0.523279 10.1522 0.826092C9.65349 1.06367 9.17939 1.34314 8.73261 1.66037C8.16218 2.06618 7.9668 2.83248 8.30632 3.44635C8.75447 4.25591 8.78384 5.27215 8.29744 6.13527C7.81719 6.99702 6.93661 7.49484 6.01573 7.52574C5.33122 7.5484 4.76557 8.08605 4.71229 8.7727C4.69316 9.01715 4.68359 9.26434 4.68359 9.51359C4.68359 9.76285 4.69316 10.01 4.71229 10.2545C4.76557 10.9411 5.33122 11.4788 6.01573 11.5014C6.93661 11.5317 7.81719 12.0295 8.29744 12.8919C8.78384 13.7557 8.75447 14.772 8.30632 15.5808C7.9668 16.194 8.16218 16.961 8.73261 17.3668C9.1787 17.684 9.65349 17.9635 10.1522 18.2011C10.7861 18.5032 11.5492 18.2972 11.9154 17.6957C12.395 16.9068 13.2585 16.3801 14.2483 16.3801C15.2382 16.3801 16.101 16.9061 16.5813 17.6957C16.9475 18.2979 17.7105 18.5039 18.3445 18.2011C18.8432 17.9635 19.318 17.684 19.7641 17.3668C20.3345 16.961 20.5299 16.1947 20.1904 15.5808C19.7422 14.7713 19.7128 13.755 20.1992 12.8919C20.6795 12.0302 21.5601 11.5323 22.4809 11.5014C23.1655 11.4788 23.7311 10.9411 23.7844 10.2545C23.8035 10.01 23.8131 9.76285 23.8131 9.51359C23.8131 9.26434 23.8035 9.01715 23.7844 8.7727ZM14.249 12.9468C12.3629 12.9468 10.8333 11.4094 10.8333 9.51359C10.8333 7.61775 12.3629 6.08034 14.249 6.08034C16.1352 6.08034 17.6648 7.61775 17.6648 9.51359C17.6648 11.4094 16.1352 12.9468 14.249 12.9468Z"
                                    fill="#265D91" />
                                <path
                                    d="M10.7591 19.0264C10.4571 19.0264 10.1497 18.9598 9.85935 18.8218C9.32991 18.5691 8.81824 18.2684 8.33798 17.9271C7.47312 17.3126 7.20328 16.161 7.70881 15.2471C8.05994 14.614 8.05721 13.8594 7.70266 13.2297C7.35152 12.6001 6.71346 12.2114 5.99342 12.1874C4.95436 12.1531 4.11135 11.3449 4.03074 10.308C4.01093 10.045 4 9.78 4 9.51289C4 9.24578 4.01093 8.98142 4.03074 8.71912C4.11135 7.68091 4.95504 6.87341 5.99274 6.83839C6.71346 6.81504 7.35152 6.4264 7.70129 5.7988C8.05721 5.16639 8.05926 4.41245 7.70881 3.77936C7.20328 2.86543 7.47312 1.71323 8.33798 1.09936C8.81755 0.758097 9.32923 0.457344 9.85867 0.205343C10.8192 -0.251966 11.9539 0.0776265 12.4977 0.973705C12.8734 1.59169 13.5272 1.96042 14.2479 1.96042C14.9686 1.96042 15.6224 1.59169 15.9981 0.973019C16.5426 0.0776265 17.6793 -0.251966 18.6364 0.204657C19.1659 0.457344 19.6775 0.758097 20.1578 1.09936C21.0227 1.71391 21.2925 2.86543 20.787 3.77936C20.4358 4.41245 20.4386 5.16708 20.7931 5.79674C21.1443 6.4264 21.7823 6.81504 22.5024 6.83907C23.5414 6.87341 24.3844 7.68159 24.465 8.71844C24.4848 8.98142 24.4958 9.24647 24.4958 9.51358C24.4958 9.78069 24.4848 10.045 24.465 10.3073C24.3844 11.3456 23.5407 12.1531 22.503 12.1881C21.7823 12.2114 21.1443 12.6001 20.7945 13.2277C20.4386 13.8601 20.4365 14.614 20.787 15.2471C21.2925 16.161 21.0227 17.3132 20.1578 17.9271C19.6782 18.2684 19.1665 18.5691 18.6371 18.8211C17.6746 19.2791 16.5419 18.9482 15.9974 18.0534C15.6224 17.4348 14.9686 17.066 14.2479 17.066C13.5272 17.066 12.8734 17.4348 12.4984 18.0528C12.1185 18.6762 11.4531 19.0264 10.7591 19.0264ZM10.7591 1.37402C10.6539 1.37402 10.5459 1.39737 10.4434 1.44612C9.98574 1.66448 9.54237 1.9254 9.12634 2.22066C8.83258 2.4294 8.73694 2.81256 8.90295 3.11194C9.48704 4.16663 9.48294 5.4232 8.89133 6.47378C8.31612 7.50581 7.22241 8.17324 6.03714 8.21169C5.70172 8.22268 5.4189 8.49253 5.39294 8.82624C5.37586 9.05284 5.36629 9.28218 5.36629 9.51358C5.36629 9.74498 5.37586 9.97501 5.39294 10.2023C5.4189 10.5346 5.70172 10.8045 6.03783 10.8155C7.22172 10.8546 8.31612 11.5213 8.8927 12.5561C9.48226 13.6033 9.48704 14.8598 8.90295 15.9152C8.73694 16.2146 8.83258 16.5978 9.12634 16.8065C9.54169 17.1018 9.98573 17.3627 10.4441 17.581C10.7714 17.7376 11.1539 17.6318 11.3322 17.3373C11.9573 16.308 13.0469 15.6934 14.2479 15.6934C15.4489 15.6934 16.5385 16.3087 17.1636 17.338C17.3425 17.6325 17.7237 17.7362 18.0523 17.581C18.51 17.3627 18.9534 17.1018 19.3694 16.8065C19.6632 16.5978 19.7588 16.2146 19.5928 15.9152C19.0087 14.8605 19.0128 13.604 19.6044 12.5534C20.1797 11.5213 21.2734 10.8539 22.4586 10.8155C22.7941 10.8045 23.0769 10.5346 23.1028 10.2009C23.1199 9.97432 23.1295 9.74498 23.1295 9.51358C23.1295 9.28218 23.1199 9.05215 23.1028 8.82487C23.0769 8.49253 22.7941 8.22268 22.458 8.21169C21.2741 8.17255 20.1797 7.50581 19.6031 6.47103C19.0135 5.42389 19.0087 4.16732 19.5928 3.11194C19.7588 2.81256 19.6632 2.4294 19.3694 2.22066C18.9541 1.9254 18.51 1.66448 18.0517 1.44612C17.7244 1.29025 17.3425 1.39531 17.1642 1.6892C16.5385 2.71917 15.4482 3.33372 14.2479 3.33372C13.0476 3.33372 11.9573 2.71917 11.3315 1.6892C11.2086 1.48663 10.99 1.37402 10.7591 1.37402Z"
                                    fill="#265D91" />
                            </g>
                            <defs>
                                <filter id="filter0_d_339_1096" x="0" y="0" width="28.4961" height="27.0264"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                        result="effect1_dropShadow_339_1096" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_339_1096"
                                        result="shape" />
                                </filter>
                            </defs>
                        </svg>



                        Paramètres
                    </h1>

                </div>
                <!--end::Title-->
                <!--begin::Breadcrumb-->
                <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                    <!--begin::Item-->
                    <li class="breadcrumb-item text-muted">
                        <a  class="text-muted"  routerLink="/">Accueil</a>
                    </li>
                    <!--end::Item-->
                    <!--begin::Item-->

                    <!--end::Item-->
                    <!--begin::Item-->
                    <li class="breadcrumb-item">
                        <span class="bullet bg-gray-400 w-5px h-2px"></span>
                    </li>
                    <li class="breadcrumb-item text-muted"><a class="text-muted" routerLink="/acceuil/parametres/parametrage-acteur">Paramètres</a></li>

                    <!--end::Item-->
                </ul>
                <!--end::Breadcrumb-->
            </div>
            <!--end::Page title-->
            <!--begin::Actions-->

            <!--end::Actions-->
        </div>
        <!--end::Toolbar container-->
    </div>
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card mb-5 pb-8">
            <div class="container-fluid">
                <div class="title">
                    <h4>Paramétrage page profil </h4>
                </div>

            </div>

            <div class="container-fluid">
                <div class="card-body pt-5">
                    <!--begin::Table-->
                    <div class="">
                        <table class="table align-middle   fs-6 gy-5 mb-4" id="kt_customers_table">
                            <thead>
                                <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">

                                    <th class="min-w-200px">NOM DE LA PAGE</th>
                                    <th class="min-w-200px">INFORMATIONS PAR DéFAUT</th>
                                </tr>
                            </thead>
                            <tbody class="fw-semibold text-gray-600">
                                <tr *ngFor="let page of listPages ; let i =index">

                                    <td [ngClass]="'td-bg' + (i % 3 + 1)">
                                        <span>{{page.name}}</span>
                                    </td>
                                    <td>
                                        <div class="chekcs">
                                            <div class="row">
                                                <div class="col-lg-6" *ngFor="let subPage of page.sub_page">
                                                    <div class="form-check form-check-custom form-check-solid mb-4">
                                                        <input class="form-check-input" (change)="changeSelection(subPage)" type="checkbox" value="1"
                                                            id="flexCheckDefault" [checked]="!subPage?.page_acteur?.length "  [disabled]="subPage.name==='Nom' || subPage.name==='Image' || subPage.name==='Entreprise' || subPage.name==='Logo' || subPage.name==='Nom entreprise' || subPage.name==='Logo entreprise'"/>
                                                        <label class="form-check-label" for="flexCheckDefault" >
                                                            {{subPage.name}}
                                                        </label>
                                                    </div>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </td>


                                </tr>

                            </tbody>
                            <!--end::Table body-->
                        </table>

                    </div>
                    <div class="save-btn mt-5" *ngIf="listPages.length">
                        <button (click)="changeSubPageState()"  class="btn save">Enregistrer</button>
                    </div>
                    <!--end::Table-->
                </div>
                <!--end::Card body-->
            </div>
            <div class="alert alert-warning text-center mt-5" role="alert"
            *ngIf="!listPages.length">
            <img src="/assets/media/logos/logo-no-data.png" alt="" class="mb-5">
            <span class="empty-list">
              La liste est vide
            </span>
          </div>
            <!-- <div class="container-fluid  mb-5">
                <div class="item">
                    <div class="title">
                        <h4> Contact et documents</h4>
                    </div>

                    <div class="chekcs">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Nom
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Client
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Responsable
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Certification
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        CV
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Date début contrat
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Mobilité
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        TJM (chat)
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Mobilité
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        TJM (chat)
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        CV
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Date début contrat
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        CV
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-check form-check-custom form-check-solid mb-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                                    <label class="form-check-label" for="flexCheckDefault">
                                        Date début contrat
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-fluid  mb-5">
                <div class="item">
                    <div class="title">
                        <h4> Informations professionnelles</h4>
                    </div>

                    <div class="chekcs">
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Date de début de première expérience professionnelle
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Nombre des années d'expérience
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Niveau en Anglais
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Niveau en Français
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Disponibilité
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Intéressé par
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Poste souhaité
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Salaire brut/an souhaité (pour un CDI Français)
                            </label>
                        </div>
                    </div>
                </div>
            </div>


            <div class="container-fluid  mb-5">
                <div class="item">
                    <div class="title">
                        <h4> Compétences maitrisées</h4>
                    </div>

                    <div class="chekcs">
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Catégories
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid mb-4">
                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" />
                            <label class="form-check-label" for="flexCheckDefault">
                                Modules
                            </label>
                        </div>

                    </div>
                </div>
            </div> -->

        </div>
    </div>
    <!--end::Content container-->
</div>

